export interface MailMergeOptionsType {
  label: JSX.Element;
  title: string;
  options: {
    label: string;
    value: string;
  }[];
}

export const getMailMergeValue = (value: string): string => `@{${value}}`;

export const filterMailMergeOptions = (options: MailMergeOptionsType[], searchValue: string)
: MailMergeOptionsType[] => options.map((option) => ({
  ...option,
  options: option.options?.filter(({ label }) => label.toLowerCase().includes(searchValue.toLowerCase())),
})).filter((option) => option.options?.length);

export const isMailMergeUsed = (value: string): boolean => value.includes('@{');
